import React from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng/errorBoundary';
import NewsLine from './newsLine/';
import styles from './index.css';
import NewBox from '../newBox/';
/**
 * 定义 NewsList 组件
 */
class NewsList extends React.PureComponent {
    static propTypes = {
        content: PropTypes.array,
    };

    /**
     * 渲染网页布局
     */
    render() {
        const { content = [] } = this.props;
        const newsStream = content.map((item, index) => {
            if (item.type === 'ad') {
                return <div key={index} className={styles.ad} ref={item.ref} />;
            } else if (item.type === 'mix') {
                return <NewBox content={item} key={index} />;
            }

            return <NewsLine content={item} key={index} />;
        });

        return <ul>{newsStream}</ul>;
    }
}

export default errorBoundary(NewsList);
